import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CategoryInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ColumnMetadata = {
  __typename?: 'ColumnMetadata';
  name: Scalars['String'];
};

export type CreateParameterInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  dataTypeId: Scalars['Int'];
  userRoleIds: Array<Scalars['Int']>;
  queryFieldName: Scalars['String'];
  query?: Maybe<Scalars['String']>;
};

export type CreateReportColumnInput = {
  name: Scalars['String'];
  isDefault: Scalars['Boolean'];
  dataTypeId: Scalars['Int'];
  userRoleIds: Array<Scalars['Int']>;
  queryFieldName: Scalars['String'];
};

export type CreateReportInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  userRoleIds: Array<Scalars['Int']>;
  category: CategoryInput;
  reportDefinitionColumns: Array<Maybe<CreateReportColumnInput>>;
  query: Scalars['String'];
  parameterIds: Array<Scalars['Int']>;
};

export type CreatedObject = {
  __typename?: 'CreatedObject';
  id: Scalars['Int'];
};

export type DataStateInput = {
  reportDefinitionId: Scalars['Int'];
  environmentId: Scalars['Int'];
  deployedMessage?: Maybe<Scalars['String']>;
};

export type DataType = {
  __typename?: 'DataType';
  id: Scalars['Int'];
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type DeleteSavedReportInput = {
  savedReportId: Scalars['Int'];
};

export type DisableDeployMessageInput = {
  reportId: Scalars['Int'];
};

export type DisableReportInput = {
  reportId: Scalars['Int'];
};

export type DownloadReportJobStatus = {
  __typename?: 'DownloadReportJobStatus';
  completed: Scalars['Boolean'];
  expiration: Scalars['String'];
  hasError: Scalars['Boolean'];
  fileUrl: Scalars['String'];
  fileName: Scalars['String'];
};

export type EditParameterInput = {
  id: Scalars['Int'];
  versionId: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  dataTypeId: Scalars['Int'];
  userRoleIds: Array<Scalars['Int']>;
  queryFieldName: Scalars['String'];
  query?: Maybe<Scalars['String']>;
};

export type EditUserReportInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  userReportColumns: Array<Maybe<UserReportColumnsInput>>;
  userReportParameters: Array<Maybe<UserReportParametersInput>>;
  userReportSchedule?: Maybe<UserReportScheduleInput>;
};

export type EditUserReportResponse = {
  __typename?: 'EditUserReportResponse';
  id?: Maybe<Scalars['Int']>;
};

export type EnableReportInput = {
  reportId: Scalars['Int'];
};

export type Environment = {
  __typename?: 'Environment';
  name: Scalars['String'];
  id: Scalars['Int'];
  precessorEnvironmentId?: Maybe<Scalars['Int']>;
  successorEnvironmentId?: Maybe<Scalars['Int']>;
};

export type ExportRecentlyGeneratedReportInput = {
  itemId: Scalars['Int'];
};

export type ExportRecentlyGeneratedReportPayload = {
  __typename?: 'ExportRecentlyGeneratedReportPayload';
  fileUrl: Scalars['String'];
};

export type ExportReportInput = {
  reportDefinitionId: Scalars['Int'];
  parameters: Scalars['String'];
  columns: Array<Scalars['String']>;
};

export type ExportSavedReportInput = {
  savedReportId: Scalars['Int'];
};

export type FetchSnapshotDataInput = {
  snapshotId: Scalars['Int'];
};

export type FetchSnapshotDataJobStatusInput = {
  snapshotId: Scalars['Int'];
  correlationId: Scalars['String'];
};

export type GeneralResponse = {
  __typename?: 'GeneralResponse';
  success: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createReport?: Maybe<Report>;
  createParameter: Parameter;
  editParameter: Parameter;
  pushToState: Report;
  updateReport?: Maybe<Report>;
  createDraft?: Maybe<Report>;
  runReport: RunReportPayload;
  saveReport: CreatedObject;
  exportReport: Scalars['String'];
  disableReport: GeneralResponse;
  enableReport: GeneralResponse;
  disableDeployMessage: Report;
  disableDeployMessageTemplate: Report;
  deleteSavedReport: GeneralResponse;
  editUserReport?: Maybe<EditUserReportResponse>;
  fetchSnapshotData: Scalars['String'];
};

export type MutationCreateReportArgs = {
  input: CreateReportInput;
};

export type MutationCreateParameterArgs = {
  input: CreateParameterInput;
};

export type MutationEditParameterArgs = {
  input: EditParameterInput;
};

export type MutationPushToStateArgs = {
  input: DataStateInput;
};

export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};

export type MutationCreateDraftArgs = {
  input: UpdateReportInput;
};

export type MutationRunReportArgs = {
  input: RunReportInput;
  bodyBuilder: Scalars['String'];
};

export type MutationSaveReportArgs = {
  input: SaveReportInput;
};

export type MutationExportReportArgs = {
  input: ExportReportInput;
  bodyBuilder: Scalars['String'];
};

export type MutationDisableReportArgs = {
  input: DisableReportInput;
};

export type MutationEnableReportArgs = {
  input: EnableReportInput;
};

export type MutationDisableDeployMessageArgs = {
  input: DisableDeployMessageInput;
};

export type MutationDisableDeployMessageTemplateArgs = {
  input: DisableDeployMessageInput;
};

export type MutationDeleteSavedReportArgs = {
  input: DeleteSavedReportInput;
};

export type MutationEditUserReportArgs = {
  input?: Maybe<EditUserReportInput>;
};

export type MutationFetchSnapshotDataArgs = {
  input: FetchSnapshotDataInput;
};

export type Parameter = {
  __typename?: 'Parameter';
  id: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  dataTypeId: Scalars['Int'];
  userRoleIds: Array<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  versionId: Scalars['Int'];
  queryFieldName: Scalars['String'];
};

export type ParameterValue = {
  __typename?: 'ParameterValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  categories?: Maybe<Array<Category>>;
  userReports?: Maybe<Array<Maybe<UserReport>>>;
  roles?: Maybe<Array<Role>>;
  parameters?: Maybe<Array<Maybe<Parameter>>>;
  storeProcedureReports?: Maybe<Array<StoreProcedureReport>>;
  storeProcedureParameters?: Maybe<Array<StoreProcedureParameter>>;
  reports?: Maybe<Array<Report>>;
  dataTypes?: Maybe<Array<DataType>>;
  isGlobalLoading: Scalars['Boolean'];
  reportViewer?: Maybe<Scalars['String']>;
  displayVisibility: Scalars['Int'];
  environments?: Maybe<Array<Environment>>;
  report: Report;
  enduserReports?: Maybe<Array<Report>>;
  enduserReport: Report;
  columnMetadataList: Array<ColumnMetadata>;
  parameterValues: Array<ParameterValue>;
  customFields?: Maybe<Array<ColumnMetadata>>;
  savedReport: UserReport;
  fetchReportData: Scalars['String'];
  runReportJobStatus: RunReportJobStatus;
  downloadReportJobStatus: DownloadReportJobStatus;
  exportSavedReport: Scalars['String'];
  exportRecentlyGeneratedReport: ExportRecentlyGeneratedReportPayload;
  runSavedReportData: RunReportResponse;
  fullDataSavedReport: UserReport;
  selectedEnvName: Scalars['String'];
  reportSnapshots?: Maybe<Array<ReportSnapshot>>;
  fetchSnapshotData: SnapshotDataPayload;
  fetchSnapshotDataJobStatus: SnapshotDataPayload;
};

export type QueryDataTypesArgs = {
  kind: Scalars['Int'];
};

export type QueryReportViewerArgs = {
  pathBuilder: Scalars['String'];
  reportId: Scalars['String'];
  environment: Scalars['String'];
  queryLimit: Scalars['Int'];
  queryOffset: Scalars['Int'];
};

export type QueryReportArgs = {
  id: Scalars['Int'];
};

export type QueryEnduserReportsArgs = {
  environmentName: Scalars['String'];
};

export type QueryEnduserReportArgs = {
  id: Scalars['Int'];
};

export type QueryColumnMetadataListArgs = {
  query: Scalars['String'];
};

export type QueryParameterValuesArgs = {
  id: Scalars['Int'];
  versionId: Scalars['Int'];
  reportDefinitionId: Scalars['Int'];
};

export type QueryCustomFieldsArgs = {
  companyId: Scalars['Int'];
  environmentId: Scalars['Int'];
};

export type QuerySavedReportArgs = {
  id: Scalars['Int'];
};

export type QueryFetchReportDataArgs = {
  correlationId: Scalars['String'];
  page: Scalars['Int'];
};

export type QueryRunReportJobStatusArgs = {
  correlationId: Scalars['String'];
};

export type QueryDownloadReportJobStatusArgs = {
  correlationId: Scalars['String'];
};

export type QueryExportSavedReportArgs = {
  input: ExportSavedReportInput;
};

export type QueryExportRecentlyGeneratedReportArgs = {
  input: ExportRecentlyGeneratedReportInput;
};

export type QueryRunSavedReportDataArgs = {
  input: RunSavedReportInput;
};

export type QueryFullDataSavedReportArgs = {
  id: Scalars['Int'];
};

export type QueryFetchSnapshotDataArgs = {
  input: FetchSnapshotDataInput;
};

export type QueryFetchSnapshotDataJobStatusArgs = {
  input: FetchSnapshotDataJobStatusInput;
};

export type Report = {
  __typename?: 'Report';
  id: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  displayCustomFields?: Maybe<Scalars['Boolean']>;
  deployedMessage?: Maybe<Scalars['String']>;
  userIdHideDeployedMessages?: Maybe<Array<Scalars['Int']>>;
  category: Category;
  reportEnvironment: Environment;
  parameters?: Maybe<Array<Parameter>>;
  parameterIds?: Maybe<Array<Scalars['Int']>>;
  deployedAt?: Maybe<Scalars['String']>;
  query: Scalars['String'];
  userRoleIds?: Maybe<Array<Scalars['Int']>>;
  reportDefinitionColumns?: Maybe<Array<ReportDefinitionColumn>>;
  reportId?: Maybe<Scalars['Int']>;
  modifiedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  canUpdate?: Maybe<Scalars['Boolean']>;
  canCreateDraft?: Maybe<Scalars['Boolean']>;
  drafts?: Maybe<Array<Report>>;
  isDisabled?: Maybe<Scalars['Boolean']>;
};

export type ReportDefinition = {
  __typename?: 'ReportDefinition';
  deployedMessage: Scalars['String'];
  id: Scalars['Int'];
  isDisabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ReportDefinitionColumn = {
  __typename?: 'ReportDefinitionColumn';
  id: Scalars['Int'];
  name: Scalars['String'];
  isDefault: Scalars['Boolean'];
  dataTypeId: Scalars['Int'];
  userRoles: Array<Role>;
  queryFieldName?: Maybe<Scalars['String']>;
};

export type ReportSnapshot = {
  __typename?: 'ReportSnapshot';
  id: Scalars['Int'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  createdAt: Scalars['String'];
  reportDefinitionName: Scalars['String'];
  reportDefinitionId?: Maybe<Scalars['Int']>;
  userReportId?: Maybe<Scalars['Int']>;
  columns: Array<Scalars['String']>;
  parameters: Scalars['String'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['Int'];
  name: Scalars['String'];
  displayName: Scalars['String'];
};

export type RunReportInput = {
  reportDefinitionId: Scalars['Int'];
  parameters: Scalars['String'];
  columns: Array<Scalars['String']>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};

export type RunReportJobStatus = {
  __typename?: 'RunReportJobStatus';
  completed: Scalars['Boolean'];
  expiration: Scalars['String'];
  hasError: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type RunReportPayload = {
  __typename?: 'RunReportPayload';
  exportFileCorrelationId: Scalars['String'];
  reportCorrelationId: Scalars['String'];
};

export type RunReportResponse = {
  __typename?: 'RunReportResponse';
  reportCorrelationId: Scalars['String'];
  exportFileCorrelationId: Scalars['String'];
};

export type RunSavedReportInput = {
  savedReportId: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type SaveReportInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  reportDefinitionId: Scalars['Int'];
  userReportColumns: Array<Maybe<UserReportColumnsInput>>;
  userReportParameters: Array<Maybe<UserReportParametersInput>>;
  userReportSchedule?: Maybe<UserReportScheduleInput>;
};

export type SnapshotDataPayload = {
  __typename?: 'SnapshotDataPayload';
  maximumRows: Scalars['Int'];
  hasMore: Scalars['Boolean'];
  hasError: Scalars['Boolean'];
  data: Scalars['String'];
  reportDefinitionName: Scalars['String'];
  userReportName: Scalars['String'];
  completed: Scalars['Boolean'];
  expiration: Scalars['String'];
};

export type StoreProcedureParameter = {
  __typename?: 'StoreProcedureParameter';
  name: Scalars['String'];
};

export type StoreProcedureReport = {
  __typename?: 'StoreProcedureReport';
  name: Scalars['String'];
};

export type UpdateReportInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
  description: Scalars['String'];
  userRoleIds: Array<Scalars['Int']>;
  category: CategoryInput;
  reportDefinitionColumns: Array<Maybe<CreateReportColumnInput>>;
  query: Scalars['String'];
  parameterIds: Array<Scalars['Int']>;
};

export type UserReport = {
  __typename?: 'UserReport';
  name: Scalars['String'];
  id: Scalars['Int'];
  description: Scalars['String'];
  reportDefinitionId: Scalars['Int'];
  canShowDeployedMessage: Scalars['Boolean'];
  reportDefinition: ReportDefinition;
  userReportSchedule?: Maybe<UserReportSchedule>;
  userReportColumns?: Maybe<Array<Maybe<UserReportColumns>>>;
  userReportParameters?: Maybe<Array<Maybe<UserReportParameters>>>;
};

export type UserReportSchedule = {
  __typename?: 'UserReportSchedule';
  scheduleType: Scalars['String'];
  interval: Scalars['Int'];
  time: Scalars['String'];
  daysOfWeek?: Maybe<Array<Scalars['String']>>;
  specialDay?: Maybe<Scalars['String']>;
  dayOfMonth?: Maybe<Scalars['String']>;
  scheduleTimezone?: Maybe<Scalars['String']>;
};

export type UserReportScheduleInput = {
  scheduleType: Scalars['String'];
  interval: Scalars['Int'];
  time: Scalars['String'];
  daysOfWeek?: Maybe<Array<Maybe<Scalars['String']>>>;
  dayOfMonth?: Maybe<Scalars['Int']>;
  scheduleTimezone: Scalars['String'];
  specialDay?: Maybe<Scalars['String']>;
};

export type UserReportColumns = {
  __typename?: 'userReportColumns';
  columnQueryFieldName: Scalars['String'];
  order: Scalars['Int'];
  id: Scalars['Int'];
};

export type UserReportColumnsInput = {
  columnQueryFieldName: Scalars['String'];
};

export type UserReportParameters = {
  __typename?: 'userReportParameters';
  id: Scalars['Int'];
  parameterId: Scalars['Int'];
  parameterValue: Array<Scalars['String']>;
};

export type UserReportParametersInput = {
  parameterId: Scalars['Int'];
  parameterValue: Scalars['String'];
};

export type ParametersQueryVariables = Exact<{ [key: string]: never }>;

export type ParametersQuery = { __typename?: 'Query' } & {
  parameters?: Maybe<
    Array<Maybe<{ __typename?: 'Parameter' } & ParameterDetailsFragment>>
  >;
};

export type CategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type CategoriesQuery = { __typename?: 'Query' } & {
  categories?: Maybe<
    Array<{ __typename?: 'Category' } & Pick<Category, 'name' | 'id'>>
  >;
};

export type RolesQueryVariables = Exact<{ [key: string]: never }>;

export type RolesQuery = { __typename?: 'Query' } & {
  roles?: Maybe<
    Array<{ __typename?: 'Role' } & Pick<Role, 'name' | 'id' | 'displayName'>>
  >;
};

export type ColumnMetadataListQueryVariables = Exact<{
  query: Scalars['String'];
}>;

export type ColumnMetadataListQuery = { __typename?: 'Query' } & {
  columnMetadataList: Array<
    { __typename?: 'ColumnMetadata' } & Pick<ColumnMetadata, 'name'>
  >;
};

export type ReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type ReportQuery = { __typename?: 'Query' } & {
  report: { __typename?: 'Report' } & Pick<
    Report,
    'userRoleIds' | 'parameterIds' | 'displayCustomFields'
  > & {
      reportDefinitionColumns?: Maybe<
        Array<
          { __typename?: 'ReportDefinitionColumn' } & Pick<
            ReportDefinitionColumn,
            'id' | 'name' | 'isDefault' | 'dataTypeId' | 'queryFieldName'
          > & {
              userRoles: Array<
                { __typename?: 'Role' } & Pick<Role, 'name' | 'id'>
              >;
            }
        >
      >;
    } & ReportDetailsFragment;
};

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;

export type CreateReportMutation = { __typename?: 'Mutation' } & {
  createReport?: Maybe<{ __typename?: 'Report' } & Pick<Report, 'id'>>;
};

export type UpdateReportMutationVariables = Exact<{
  input: UpdateReportInput;
}>;

export type UpdateReportMutation = { __typename?: 'Mutation' } & {
  updateReport?: Maybe<{ __typename?: 'Report' } & Pick<Report, 'id'>>;
};

export type CreateDraftMutationVariables = Exact<{
  input: UpdateReportInput;
}>;

export type CreateDraftMutation = { __typename?: 'Mutation' } & {
  createDraft?: Maybe<{ __typename?: 'Report' } & Pick<Report, 'id'>>;
};

export type PushToStateMutationVariables = Exact<{
  input: DataStateInput;
}>;

export type PushToStateMutation = { __typename?: 'Mutation' } & {
  pushToState: { __typename?: 'Report' } & Pick<Report, 'id' | 'deployedAt'> & {
      reportEnvironment: { __typename?: 'Environment' } & Pick<
        Environment,
        'id' | 'name' | 'precessorEnvironmentId' | 'successorEnvironmentId'
      >;
    };
};

export type DisableReportMutationVariables = Exact<{
  input: DisableReportInput;
}>;

export type DisableReportMutation = { __typename?: 'Mutation' } & {
  disableReport: { __typename?: 'GeneralResponse' } & Pick<
    GeneralResponse,
    'success'
  >;
};

export type EnableReportMutationVariables = Exact<{
  input: EnableReportInput;
}>;

export type EnableReportMutation = { __typename?: 'Mutation' } & {
  enableReport: { __typename?: 'GeneralResponse' } & Pick<
    GeneralResponse,
    'success'
  >;
};

export type ReportsQueryVariables = Exact<{ [key: string]: never }>;

export type ReportsQuery = { __typename?: 'Query' } & {
  reports?: Maybe<
    Array<
      { __typename?: 'Report' } & {
        drafts?: Maybe<
          Array<{ __typename?: 'Report' } & ReportDetailsFragment>
        >;
      } & ReportDetailsFragment
    >
  >;
};

export type EnvironmentsQueryVariables = Exact<{ [key: string]: never }>;

export type EnvironmentsQuery = { __typename?: 'Query' } & {
  environments?: Maybe<
    Array<
      { __typename?: 'Environment' } & Pick<
        Environment,
        'name' | 'id' | 'precessorEnvironmentId' | 'successorEnvironmentId'
      >
    >
  >;
};

export type ReportDetailsFragment = { __typename?: 'Report' } & Pick<
  Report,
  | 'id'
  | 'name'
  | 'description'
  | 'displayCustomFields'
  | 'deployedAt'
  | 'query'
  | 'reportId'
  | 'modifiedAt'
  | 'createdAt'
  | 'canUpdate'
  | 'canCreateDraft'
  | 'isDisabled'
> & {
    reportEnvironment: { __typename?: 'Environment' } & Pick<
      Environment,
      'id' | 'name' | 'precessorEnvironmentId' | 'successorEnvironmentId'
    >;
    category: { __typename?: 'Category' } & Pick<Category, 'name' | 'id'>;
  };

export type ParameterDetailsFragment = { __typename?: 'Parameter' } & Pick<
  Parameter,
  | 'name'
  | 'id'
  | 'description'
  | 'dataTypeId'
  | 'userRoleIds'
  | 'query'
  | 'versionId'
  | 'queryFieldName'
>;

export type CreateParameterMutationVariables = Exact<{
  input: CreateParameterInput;
}>;

export type CreateParameterMutation = { __typename?: 'Mutation' } & {
  createParameter: { __typename?: 'Parameter' } & Pick<
    Parameter,
    'id' | 'versionId'
  >;
};

export type RunReportMutationVariables = Exact<{
  input: RunReportInput;
  bodyBuilder: Scalars['String'];
}>;

export type RunReportMutation = { __typename?: 'Mutation' } & {
  runReport: { __typename?: 'RunReportPayload' } & Pick<
    RunReportPayload,
    'exportFileCorrelationId' | 'reportCorrelationId'
  >;
};

export type EditParameterMutationVariables = Exact<{
  input: EditParameterInput;
}>;

export type EditParameterMutation = { __typename?: 'Mutation' } & {
  editParameter: { __typename?: 'Parameter' } & ParameterDetailsFragment;
};

export type ExportReportMutationVariables = Exact<{
  input: ExportReportInput;
  bodyBuilder: Scalars['String'];
}>;

export type ExportReportMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'exportReport'
>;

export type DeleteSavedReportMutationVariables = Exact<{
  input: DeleteSavedReportInput;
}>;

export type DeleteSavedReportMutation = { __typename?: 'Mutation' } & {
  deleteSavedReport: { __typename?: 'GeneralResponse' } & Pick<
    GeneralResponse,
    'success'
  >;
};

export type EditUserReportMutationVariables = Exact<{
  input: EditUserReportInput;
}>;

export type EditUserReportMutation = { __typename?: 'Mutation' } & {
  editUserReport?: Maybe<
    { __typename?: 'EditUserReportResponse' } & Pick<
      EditUserReportResponse,
      'id'
    >
  >;
};

export type FetchSnapshotDataMutationVariables = Exact<{
  input: FetchSnapshotDataInput;
}>;

export type FetchSnapshotDataMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'fetchSnapshotData'
>;

export type DataTypesQueryVariables = Exact<{
  kind: Scalars['Int'];
}>;

export type DataTypesQuery = { __typename?: 'Query' } & {
  dataTypes?: Maybe<
    Array<
      { __typename?: 'DataType' } & Pick<
        DataType,
        'displayName' | 'id' | 'name'
      >
    >
  >;
};

export type StoreProcedureReportsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StoreProcedureReportsQuery = { __typename?: 'Query' } & {
  storeProcedureReports?: Maybe<
    Array<
      { __typename?: 'StoreProcedureReport' } & Pick<
        StoreProcedureReport,
        'name'
      >
    >
  >;
};

export type StoreProcedureParametersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type StoreProcedureParametersQuery = { __typename?: 'Query' } & {
  storeProcedureParameters?: Maybe<
    Array<
      { __typename?: 'StoreProcedureParameter' } & Pick<
        StoreProcedureParameter,
        'name'
      >
    >
  >;
};

export type EnvironmentUserQueryVariables = Exact<{ [key: string]: never }>;

export type EnvironmentUserQuery = { __typename?: 'Query' } & {
  environments?: Maybe<
    Array<
      { __typename?: 'Environment' } & Pick<
        Environment,
        'name' | 'id' | 'precessorEnvironmentId' | 'successorEnvironmentId'
      >
    >
  >;
};

export type IsGlobalLoadingQueryVariables = Exact<{ [key: string]: never }>;

export type IsGlobalLoadingQuery = { __typename?: 'Query' } & Pick<
  Query,
  'isGlobalLoading'
>;

export type DisplayVisibilityQueryVariables = Exact<{ [key: string]: never }>;

export type DisplayVisibilityQuery = { __typename?: 'Query' } & Pick<
  Query,
  'displayVisibility'
>;

export type SelectedEnvNameQueryVariables = Exact<{ [key: string]: never }>;

export type SelectedEnvNameQuery = { __typename?: 'Query' } & Pick<
  Query,
  'selectedEnvName'
>;

export type ProductionReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type ProductionReportQuery = { __typename?: 'Query' } & {
  enduserReport: { __typename?: 'Report' } & Pick<
    Report,
    'id' | 'name' | 'displayCustomFields'
  > & {
      parameters?: Maybe<
        Array<
          { __typename?: 'Parameter' } & Pick<
            Parameter,
            | 'id'
            | 'name'
            | 'description'
            | 'dataTypeId'
            | 'userRoleIds'
            | 'versionId'
            | 'queryFieldName'
            | 'query'
          >
        >
      >;
      reportDefinitionColumns?: Maybe<
        Array<
          { __typename?: 'ReportDefinitionColumn' } & Pick<
            ReportDefinitionColumn,
            'id' | 'name' | 'isDefault' | 'dataTypeId' | 'queryFieldName'
          > & {
              userRoles: Array<
                { __typename?: 'Role' } & Pick<
                  Role,
                  'id' | 'displayName' | 'name'
                >
              >;
            }
        >
      >;
      reportEnvironment: { __typename?: 'Environment' } & Pick<
        Environment,
        'id' | 'name'
      >;
    };
};

export type CustomFieldsQueryVariables = Exact<{
  companyId: Scalars['Int'];
  environmentId: Scalars['Int'];
}>;

export type CustomFieldsQuery = { __typename?: 'Query' } & {
  customFields?: Maybe<
    Array<{ __typename?: 'ColumnMetadata' } & Pick<ColumnMetadata, 'name'>>
  >;
};

export type SavedReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type SavedReportQuery = { __typename?: 'Query' } & {
  savedReport: { __typename?: 'UserReport' } & Pick<
    UserReport,
    'id' | 'name'
  > & {
      reportDefinition: { __typename?: 'ReportDefinition' } & Pick<
        ReportDefinition,
        'id' | 'name'
      >;
    };
};

export type FetchReportDataQueryVariables = Exact<{
  correlationId: Scalars['String'];
  page: Scalars['Int'];
}>;

export type FetchReportDataQuery = { __typename?: 'Query' } & Pick<
  Query,
  'fetchReportData'
>;

export type GetRunReportJobStatusQueryVariables = Exact<{
  correlationId: Scalars['String'];
}>;

export type GetRunReportJobStatusQuery = { __typename?: 'Query' } & {
  runReportJobStatus: { __typename?: 'RunReportJobStatus' } & Pick<
    RunReportJobStatus,
    'completed' | 'expiration' | 'hasError' | 'totalRows'
  >;
};

export type GetDownloadReportJobStatusQueryVariables = Exact<{
  correlationId: Scalars['String'];
}>;

export type GetDownloadReportJobStatusQuery = { __typename?: 'Query' } & {
  downloadReportJobStatus: { __typename?: 'DownloadReportJobStatus' } & Pick<
    DownloadReportJobStatus,
    'completed' | 'expiration' | 'hasError' | 'fileUrl' | 'fileName'
  >;
};

export type ExportSavedReportQueryVariables = Exact<{
  input: ExportSavedReportInput;
}>;

export type ExportSavedReportQuery = { __typename?: 'Query' } & Pick<
  Query,
  'exportSavedReport'
>;

export type ExportRecentlyGeneratedReportQueryVariables = Exact<{
  input: ExportRecentlyGeneratedReportInput;
}>;

export type ExportRecentlyGeneratedReportQuery = { __typename?: 'Query' } & {
  exportRecentlyGeneratedReport: {
    __typename?: 'ExportRecentlyGeneratedReportPayload';
  } & Pick<ExportRecentlyGeneratedReportPayload, 'fileUrl'>;
};

export type RunSavedReportDataQueryVariables = Exact<{
  input: RunSavedReportInput;
}>;

export type RunSavedReportDataQuery = { __typename?: 'Query' } & {
  runSavedReportData: { __typename?: 'RunReportResponse' } & Pick<
    RunReportResponse,
    'reportCorrelationId' | 'exportFileCorrelationId'
  >;
};

export type FetchSnapshotDataJobStatusQueryVariables = Exact<{
  input: FetchSnapshotDataJobStatusInput;
}>;

export type FetchSnapshotDataJobStatusQuery = { __typename?: 'Query' } & {
  fetchSnapshotDataJobStatus: { __typename?: 'SnapshotDataPayload' } & Pick<
    SnapshotDataPayload,
    | 'maximumRows'
    | 'hasMore'
    | 'hasError'
    | 'data'
    | 'reportDefinitionName'
    | 'userReportName'
    | 'completed'
    | 'expiration'
  >;
};

export type ReportViewerQueryVariables = Exact<{
  reportId: Scalars['String'];
  environment: Scalars['String'];
  pathBuilder: Scalars['String'];
  queryLimit: Scalars['Int'];
  queryOffset: Scalars['Int'];
}>;

export type ReportViewerQuery = { __typename?: 'Query' } & Pick<
  Query,
  'reportViewer'
>;

export type SaveReportMutationVariables = Exact<{
  input: SaveReportInput;
}>;

export type SaveReportMutation = { __typename?: 'Mutation' } & {
  saveReport: { __typename?: 'CreatedObject' } & Pick<CreatedObject, 'id'>;
};

export type ParameterValuesQueryVariables = Exact<{
  id: Scalars['Int'];
  versionId: Scalars['Int'];
  reportDefinitionId: Scalars['Int'];
}>;

export type ParameterValuesQuery = { __typename?: 'Query' } & {
  parameterValues: Array<
    { __typename?: 'ParameterValue' } & Pick<ParameterValue, 'key' | 'value'>
  >;
};

export type EndUserReportsQueryVariables = Exact<{
  environmentName: Scalars['String'];
}>;

export type EndUserReportsQuery = { __typename?: 'Query' } & {
  enduserReports?: Maybe<
    Array<
      { __typename?: 'Report' } & Pick<
        Report,
        | 'name'
        | 'description'
        | 'id'
        | 'parameterIds'
        | 'deployedMessage'
        | 'userIdHideDeployedMessages'
        | 'deployedAt'
        | 'query'
      > & {
          reportEnvironment: { __typename?: 'Environment' } & Pick<
            Environment,
            'id' | 'name' | 'precessorEnvironmentId' | 'successorEnvironmentId'
          >;
          category: { __typename?: 'Category' } & Pick<Category, 'name' | 'id'>;
        }
    >
  >;
};

export type DisableDeployMessageTemplateMutationVariables = Exact<{
  input: DisableDeployMessageInput;
}>;

export type DisableDeployMessageTemplateMutation = {
  __typename?: 'Mutation';
} & {
  disableDeployMessageTemplate: { __typename?: 'Report' } & Pick<Report, 'id'>;
};

export type FullDataSavedReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type FullDataSavedReportQuery = { __typename?: 'Query' } & {
  fullDataSavedReport: { __typename?: 'UserReport' } & Pick<
    UserReport,
    'id' | 'name' | 'description'
  > & {
      reportDefinition: { __typename?: 'ReportDefinition' } & Pick<
        ReportDefinition,
        'id' | 'name'
      >;
      userReportColumns?: Maybe<
        Array<
          Maybe<
            { __typename?: 'userReportColumns' } & Pick<
              UserReportColumns,
              'columnQueryFieldName' | 'order' | 'id'
            >
          >
        >
      >;
      userReportParameters?: Maybe<
        Array<
          Maybe<
            { __typename?: 'userReportParameters' } & Pick<
              UserReportParameters,
              'id' | 'parameterId' | 'parameterValue'
            >
          >
        >
      >;
      userReportSchedule?: Maybe<
        { __typename?: 'UserReportSchedule' } & Pick<
          UserReportSchedule,
          | 'scheduleType'
          | 'interval'
          | 'time'
          | 'daysOfWeek'
          | 'dayOfMonth'
          | 'specialDay'
          | 'scheduleTimezone'
        >
      >;
    };
};

export type ReportSnapshotsQueryVariables = Exact<{ [key: string]: never }>;

export type ReportSnapshotsQuery = { __typename?: 'Query' } & {
  reportSnapshots?: Maybe<
    Array<
      { __typename?: 'ReportSnapshot' } & Pick<
        ReportSnapshot,
        | 'id'
        | 'name'
        | 'description'
        | 'type'
        | 'createdAt'
        | 'reportDefinitionName'
        | 'reportDefinitionId'
        | 'userReportId'
        | 'columns'
        | 'parameters'
      >
    >
  >;
};

export type UserReportsQueryVariables = Exact<{ [key: string]: never }>;

export type UserReportsQuery = { __typename?: 'Query' } & {
  userReports?: Maybe<
    Array<
      Maybe<
        { __typename?: 'UserReport' } & Pick<
          UserReport,
          | 'name'
          | 'description'
          | 'id'
          | 'canShowDeployedMessage'
          | 'reportDefinitionId'
        > & {
            reportDefinition: { __typename?: 'ReportDefinition' } & Pick<
              ReportDefinition,
              'id' | 'name' | 'isDisabled' | 'deployedMessage'
            >;
            userReportSchedule?: Maybe<
              { __typename?: 'UserReportSchedule' } & Pick<
                UserReportSchedule,
                | 'scheduleType'
                | 'interval'
                | 'time'
                | 'daysOfWeek'
                | 'dayOfMonth'
                | 'specialDay'
              >
            >;
          }
      >
    >
  >;
};

export type DisableDeployMessageMutationVariables = Exact<{
  input: DisableDeployMessageInput;
}>;

export type DisableDeployMessageMutation = { __typename?: 'Mutation' } & {
  disableDeployMessage: { __typename?: 'Report' } & Pick<Report, 'id'>;
};

export const ReportDetailsFragmentDoc = gql`
  fragment ReportDetails on Report {
    id
    name
    description
    displayCustomFields
    reportEnvironment {
      id
      name
      precessorEnvironmentId
      successorEnvironmentId
    }
    deployedAt
    query
    category {
      name
      id
    }
    reportId
    modifiedAt
    createdAt
    canUpdate
    canCreateDraft
    isDisabled
  }
`;
export const ParameterDetailsFragmentDoc = gql`
  fragment ParameterDetails on Parameter {
    name
    id
    description
    dataTypeId
    userRoleIds
    query
    versionId
    queryFieldName
  }
`;
export const ParametersDocument = gql`
  query Parameters {
    parameters
      @rest(type: "Parameter", path: "api/v1/admin/parameter", method: "GET") {
      ...ParameterDetails
    }
  }
  ${ParameterDetailsFragmentDoc}
`;

/**
 * __useParametersQuery__
 *
 * To run a query within a React component, call `useParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useParametersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ParametersQuery,
    ParametersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ParametersQuery, ParametersQueryVariables>(
    ParametersDocument,
    options
  );
}
export function useParametersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ParametersQuery,
    ParametersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ParametersQuery, ParametersQueryVariables>(
    ParametersDocument,
    options
  );
}
export type ParametersQueryHookResult = ReturnType<typeof useParametersQuery>;
export type ParametersLazyQueryHookResult = ReturnType<
  typeof useParametersLazyQuery
>;
export type ParametersQueryResult = Apollo.QueryResult<
  ParametersQuery,
  ParametersQueryVariables
>;
export const CategoriesDocument = gql`
  query Categories {
    categories
      @rest(type: "Category", path: "api/v1/admin/category", method: "GET") {
      name
      id
    }
  }
`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CategoriesQuery,
    CategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  );
}
export function useCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoriesQuery,
    CategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  );
}
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<
  typeof useCategoriesLazyQuery
>;
export type CategoriesQueryResult = Apollo.QueryResult<
  CategoriesQuery,
  CategoriesQueryVariables
>;
export const RolesDocument = gql`
  query Roles {
    roles @rest(type: "Role", path: "api/v1/admin/user-role", method: "GET") {
      name
      id
      displayName
    }
  }
`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RolesQuery, RolesQueryVariables>(
    RolesDocument,
    options
  );
}
export function useRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(
    RolesDocument,
    options
  );
}
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<
  RolesQuery,
  RolesQueryVariables
>;
export const ColumnMetadataListDocument = gql`
  query ColumnMetadataList($query: String!) {
    columnMetadataList(query: $query)
      @rest(
        type: "ColumnMetadata"
        path: "api/v1/admin/report-environment/query/{args.query}/column-metadata"
        method: "GET"
      ) {
      name
    }
  }
`;

/**
 * __useColumnMetadataListQuery__
 *
 * To run a query within a React component, call `useColumnMetadataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useColumnMetadataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColumnMetadataListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useColumnMetadataListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ColumnMetadataListQuery,
    ColumnMetadataListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ColumnMetadataListQuery,
    ColumnMetadataListQueryVariables
  >(ColumnMetadataListDocument, options);
}
export function useColumnMetadataListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ColumnMetadataListQuery,
    ColumnMetadataListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ColumnMetadataListQuery,
    ColumnMetadataListQueryVariables
  >(ColumnMetadataListDocument, options);
}
export type ColumnMetadataListQueryHookResult = ReturnType<
  typeof useColumnMetadataListQuery
>;
export type ColumnMetadataListLazyQueryHookResult = ReturnType<
  typeof useColumnMetadataListLazyQuery
>;
export type ColumnMetadataListQueryResult = Apollo.QueryResult<
  ColumnMetadataListQuery,
  ColumnMetadataListQueryVariables
>;
export const ReportDocument = gql`
  query Report($id: Int!) {
    report(id: $id)
      @rest(
        type: "Report"
        path: "api/v1/admin/report/{args.id}"
        method: "GET"
      ) {
      ...ReportDetails
      reportDefinitionColumns {
        id
        name
        isDefault
        dataTypeId
        userRoles {
          name
          id
        }
        queryFieldName
      }
      userRoleIds
      parameterIds
      displayCustomFields
    }
  }
  ${ReportDetailsFragmentDoc}
`;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(
  baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportQuery, ReportQueryVariables>(
    ReportDocument,
    options
  );
}
export function useReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(
    ReportDocument,
    options
  );
}
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportQueryResult = Apollo.QueryResult<
  ReportQuery,
  ReportQueryVariables
>;
export const CreateReportDocument = gql`
  mutation CreateReport($input: CreateReportInput!) {
    createReport(input: $input)
      @rest(type: "Report", path: "api/v1/admin/report", method: "POST") {
      id
    }
  }
`;
export type CreateReportMutationFn = Apollo.MutationFunction<
  CreateReportMutation,
  CreateReportMutationVariables
>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReportMutation,
    CreateReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReportMutation,
    CreateReportMutationVariables
  >(CreateReportDocument, options);
}
export type CreateReportMutationHookResult = ReturnType<
  typeof useCreateReportMutation
>;
export type CreateReportMutationResult =
  Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<
  CreateReportMutation,
  CreateReportMutationVariables
>;
export const UpdateReportDocument = gql`
  mutation UpdateReport($input: UpdateReportInput!) {
    updateReport(input: $input)
      @rest(type: "Report", path: "api/v1/admin/report", method: "PUT") {
      id
    }
  }
`;
export type UpdateReportMutationFn = Apollo.MutationFunction<
  UpdateReportMutation,
  UpdateReportMutationVariables
>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReportMutation,
    UpdateReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateReportMutation,
    UpdateReportMutationVariables
  >(UpdateReportDocument, options);
}
export type UpdateReportMutationHookResult = ReturnType<
  typeof useUpdateReportMutation
>;
export type UpdateReportMutationResult =
  Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<
  UpdateReportMutation,
  UpdateReportMutationVariables
>;
export const CreateDraftDocument = gql`
  mutation CreateDraft($input: UpdateReportInput!) {
    createDraft(input: $input)
      @rest(type: "Report", path: "api/v1/admin/report/draft", method: "POST") {
      id
    }
  }
`;
export type CreateDraftMutationFn = Apollo.MutationFunction<
  CreateDraftMutation,
  CreateDraftMutationVariables
>;

/**
 * __useCreateDraftMutation__
 *
 * To run a mutation, you first call `useCreateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftMutation, { data, loading, error }] = useCreateDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDraftMutation,
    CreateDraftMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDraftMutation, CreateDraftMutationVariables>(
    CreateDraftDocument,
    options
  );
}
export type CreateDraftMutationHookResult = ReturnType<
  typeof useCreateDraftMutation
>;
export type CreateDraftMutationResult =
  Apollo.MutationResult<CreateDraftMutation>;
export type CreateDraftMutationOptions = Apollo.BaseMutationOptions<
  CreateDraftMutation,
  CreateDraftMutationVariables
>;
export const PushToStateDocument = gql`
  mutation PushToState($input: DataStateInput!) {
    pushToState(input: $input)
      @rest(
        type: "Report"
        path: "api/v1/admin/report/{args.input.reportDefinitionId}/push/{args.input.environmentId}"
        method: "POST"
      ) {
      id
      reportEnvironment {
        id
        name
        precessorEnvironmentId
        successorEnvironmentId
      }
      deployedAt
    }
  }
`;
export type PushToStateMutationFn = Apollo.MutationFunction<
  PushToStateMutation,
  PushToStateMutationVariables
>;

/**
 * __usePushToStateMutation__
 *
 * To run a mutation, you first call `usePushToStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToStateMutation, { data, loading, error }] = usePushToStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushToStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PushToStateMutation,
    PushToStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PushToStateMutation, PushToStateMutationVariables>(
    PushToStateDocument,
    options
  );
}
export type PushToStateMutationHookResult = ReturnType<
  typeof usePushToStateMutation
>;
export type PushToStateMutationResult =
  Apollo.MutationResult<PushToStateMutation>;
export type PushToStateMutationOptions = Apollo.BaseMutationOptions<
  PushToStateMutation,
  PushToStateMutationVariables
>;
export const DisableReportDocument = gql`
  mutation DisableReport($input: DisableReportInput!) {
    disableReport(input: $input)
      @rest(
        type: "GeneralResponse"
        path: "api/v1/admin/report/{args.input.reportId}/disable"
        method: "POST"
      ) {
      success
    }
  }
`;
export type DisableReportMutationFn = Apollo.MutationFunction<
  DisableReportMutation,
  DisableReportMutationVariables
>;

/**
 * __useDisableReportMutation__
 *
 * To run a mutation, you first call `useDisableReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableReportMutation, { data, loading, error }] = useDisableReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableReportMutation,
    DisableReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableReportMutation,
    DisableReportMutationVariables
  >(DisableReportDocument, options);
}
export type DisableReportMutationHookResult = ReturnType<
  typeof useDisableReportMutation
>;
export type DisableReportMutationResult =
  Apollo.MutationResult<DisableReportMutation>;
export type DisableReportMutationOptions = Apollo.BaseMutationOptions<
  DisableReportMutation,
  DisableReportMutationVariables
>;
export const EnableReportDocument = gql`
  mutation EnableReport($input: EnableReportInput!) {
    enableReport(input: $input)
      @rest(
        type: "GeneralResponse"
        path: "api/v1/admin/report/{args.input.reportId}/enable"
        method: "POST"
      ) {
      success
    }
  }
`;
export type EnableReportMutationFn = Apollo.MutationFunction<
  EnableReportMutation,
  EnableReportMutationVariables
>;

/**
 * __useEnableReportMutation__
 *
 * To run a mutation, you first call `useEnableReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableReportMutation, { data, loading, error }] = useEnableReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableReportMutation,
    EnableReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableReportMutation,
    EnableReportMutationVariables
  >(EnableReportDocument, options);
}
export type EnableReportMutationHookResult = ReturnType<
  typeof useEnableReportMutation
>;
export type EnableReportMutationResult =
  Apollo.MutationResult<EnableReportMutation>;
export type EnableReportMutationOptions = Apollo.BaseMutationOptions<
  EnableReportMutation,
  EnableReportMutationVariables
>;
export const ReportsDocument = gql`
  query Reports {
    reports @rest(type: "Report", path: "api/v1/admin/report", method: "GET") {
      ...ReportDetails
      drafts @type(name: "Report") {
        ...ReportDetails
      }
    }
  }
  ${ReportDetailsFragmentDoc}
`;

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(
    ReportsDocument,
    options
  );
}
export function useReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportsQuery, ReportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(
    ReportsDocument,
    options
  );
}
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<
  ReportsQuery,
  ReportsQueryVariables
>;
export const EnvironmentsDocument = gql`
  query Environments {
    environments
      @rest(
        type: "Environment"
        path: "api/v1/admin/report-environment"
        method: "GET"
      ) {
      name
      id
      precessorEnvironmentId
      successorEnvironmentId
    }
  }
`;

/**
 * __useEnvironmentsQuery__
 *
 * To run a query within a React component, call `useEnvironmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvironmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EnvironmentsQuery,
    EnvironmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(
    EnvironmentsDocument,
    options
  );
}
export function useEnvironmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnvironmentsQuery,
    EnvironmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EnvironmentsQuery, EnvironmentsQueryVariables>(
    EnvironmentsDocument,
    options
  );
}
export type EnvironmentsQueryHookResult = ReturnType<
  typeof useEnvironmentsQuery
>;
export type EnvironmentsLazyQueryHookResult = ReturnType<
  typeof useEnvironmentsLazyQuery
>;
export type EnvironmentsQueryResult = Apollo.QueryResult<
  EnvironmentsQuery,
  EnvironmentsQueryVariables
>;
export const CreateParameterDocument = gql`
  mutation CreateParameter($input: CreateParameterInput!) {
    createParameter(input: $input)
      @rest(type: "Parameter", path: "api/v1/admin/parameter", method: "POST") {
      id
      versionId
    }
  }
`;
export type CreateParameterMutationFn = Apollo.MutationFunction<
  CreateParameterMutation,
  CreateParameterMutationVariables
>;

/**
 * __useCreateParameterMutation__
 *
 * To run a mutation, you first call `useCreateParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createParameterMutation, { data, loading, error }] = useCreateParameterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateParameterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateParameterMutation,
    CreateParameterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateParameterMutation,
    CreateParameterMutationVariables
  >(CreateParameterDocument, options);
}
export type CreateParameterMutationHookResult = ReturnType<
  typeof useCreateParameterMutation
>;
export type CreateParameterMutationResult =
  Apollo.MutationResult<CreateParameterMutation>;
export type CreateParameterMutationOptions = Apollo.BaseMutationOptions<
  CreateParameterMutation,
  CreateParameterMutationVariables
>;
export const RunReportDocument = gql`
  mutation RunReport($input: RunReportInput!, $bodyBuilder: String!) {
    runReport(input: $input, bodyBuilder: $bodyBuilder)
      @rest(
        type: "RunReportPayload"
        path: "api/v1/end-user/report/run-report"
        method: "POST"
        bodyBuilder: $bodyBuilder
      ) {
      exportFileCorrelationId
      reportCorrelationId
    }
  }
`;
export type RunReportMutationFn = Apollo.MutationFunction<
  RunReportMutation,
  RunReportMutationVariables
>;

/**
 * __useRunReportMutation__
 *
 * To run a mutation, you first call `useRunReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runReportMutation, { data, loading, error }] = useRunReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *      bodyBuilder: // value for 'bodyBuilder'
 *   },
 * });
 */
export function useRunReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunReportMutation,
    RunReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunReportMutation, RunReportMutationVariables>(
    RunReportDocument,
    options
  );
}
export type RunReportMutationHookResult = ReturnType<
  typeof useRunReportMutation
>;
export type RunReportMutationResult = Apollo.MutationResult<RunReportMutation>;
export type RunReportMutationOptions = Apollo.BaseMutationOptions<
  RunReportMutation,
  RunReportMutationVariables
>;
export const EditParameterDocument = gql`
  mutation EditParameter($input: EditParameterInput!) {
    editParameter(input: $input)
      @rest(type: "Parameter", path: "api/v1/admin/parameter", method: "PUT") {
      ...ParameterDetails
    }
  }
  ${ParameterDetailsFragmentDoc}
`;
export type EditParameterMutationFn = Apollo.MutationFunction<
  EditParameterMutation,
  EditParameterMutationVariables
>;

/**
 * __useEditParameterMutation__
 *
 * To run a mutation, you first call `useEditParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editParameterMutation, { data, loading, error }] = useEditParameterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditParameterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditParameterMutation,
    EditParameterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditParameterMutation,
    EditParameterMutationVariables
  >(EditParameterDocument, options);
}
export type EditParameterMutationHookResult = ReturnType<
  typeof useEditParameterMutation
>;
export type EditParameterMutationResult =
  Apollo.MutationResult<EditParameterMutation>;
export type EditParameterMutationOptions = Apollo.BaseMutationOptions<
  EditParameterMutation,
  EditParameterMutationVariables
>;
export const ExportReportDocument = gql`
  mutation ExportReport($input: ExportReportInput!, $bodyBuilder: String!) {
    exportReport(input: $input, bodyBuilder: $bodyBuilder)
      @rest(
        type: "String"
        path: "api/v1/end-user/report/export-report"
        method: "POST"
        bodyBuilder: $bodyBuilder
      )
  }
`;
export type ExportReportMutationFn = Apollo.MutationFunction<
  ExportReportMutation,
  ExportReportMutationVariables
>;

/**
 * __useExportReportMutation__
 *
 * To run a mutation, you first call `useExportReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportReportMutation, { data, loading, error }] = useExportReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *      bodyBuilder: // value for 'bodyBuilder'
 *   },
 * });
 */
export function useExportReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportReportMutation,
    ExportReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportReportMutation,
    ExportReportMutationVariables
  >(ExportReportDocument, options);
}
export type ExportReportMutationHookResult = ReturnType<
  typeof useExportReportMutation
>;
export type ExportReportMutationResult =
  Apollo.MutationResult<ExportReportMutation>;
export type ExportReportMutationOptions = Apollo.BaseMutationOptions<
  ExportReportMutation,
  ExportReportMutationVariables
>;
export const DeleteSavedReportDocument = gql`
  mutation DeleteSavedReport($input: DeleteSavedReportInput!) {
    deleteSavedReport(input: $input)
      @rest(
        type: "GeneralResponse"
        path: "api/v1/end-user/report/user-report/{args.input.savedReportId}"
        method: "DELETE"
      ) {
      success
    }
  }
`;
export type DeleteSavedReportMutationFn = Apollo.MutationFunction<
  DeleteSavedReportMutation,
  DeleteSavedReportMutationVariables
>;

/**
 * __useDeleteSavedReportMutation__
 *
 * To run a mutation, you first call `useDeleteSavedReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedReportMutation, { data, loading, error }] = useDeleteSavedReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSavedReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSavedReportMutation,
    DeleteSavedReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSavedReportMutation,
    DeleteSavedReportMutationVariables
  >(DeleteSavedReportDocument, options);
}
export type DeleteSavedReportMutationHookResult = ReturnType<
  typeof useDeleteSavedReportMutation
>;
export type DeleteSavedReportMutationResult =
  Apollo.MutationResult<DeleteSavedReportMutation>;
export type DeleteSavedReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteSavedReportMutation,
  DeleteSavedReportMutationVariables
>;
export const EditUserReportDocument = gql`
  mutation EditUserReport($input: EditUserReportInput!) {
    editUserReport(input: $input)
      @rest(
        type: "UserReport"
        path: "api/v1/end-user/report/user-report"
        method: "PUT"
      ) {
      id
    }
  }
`;
export type EditUserReportMutationFn = Apollo.MutationFunction<
  EditUserReportMutation,
  EditUserReportMutationVariables
>;

/**
 * __useEditUserReportMutation__
 *
 * To run a mutation, you first call `useEditUserReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserReportMutation, { data, loading, error }] = useEditUserReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditUserReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditUserReportMutation,
    EditUserReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditUserReportMutation,
    EditUserReportMutationVariables
  >(EditUserReportDocument, options);
}
export type EditUserReportMutationHookResult = ReturnType<
  typeof useEditUserReportMutation
>;
export type EditUserReportMutationResult =
  Apollo.MutationResult<EditUserReportMutation>;
export type EditUserReportMutationOptions = Apollo.BaseMutationOptions<
  EditUserReportMutation,
  EditUserReportMutationVariables
>;
export const FetchSnapshotDataDocument = gql`
  mutation FetchSnapshotData($input: FetchSnapshotDataInput!) {
    fetchSnapshotData(input: $input)
      @rest(
        type: "String"
        path: "api/v1/end-user/report/report-snapshot/{args.input.snapshotId}/fetch-data"
        method: "POST"
      )
  }
`;
export type FetchSnapshotDataMutationFn = Apollo.MutationFunction<
  FetchSnapshotDataMutation,
  FetchSnapshotDataMutationVariables
>;

/**
 * __useFetchSnapshotDataMutation__
 *
 * To run a mutation, you first call `useFetchSnapshotDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchSnapshotDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchSnapshotDataMutation, { data, loading, error }] = useFetchSnapshotDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchSnapshotDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FetchSnapshotDataMutation,
    FetchSnapshotDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FetchSnapshotDataMutation,
    FetchSnapshotDataMutationVariables
  >(FetchSnapshotDataDocument, options);
}
export type FetchSnapshotDataMutationHookResult = ReturnType<
  typeof useFetchSnapshotDataMutation
>;
export type FetchSnapshotDataMutationResult =
  Apollo.MutationResult<FetchSnapshotDataMutation>;
export type FetchSnapshotDataMutationOptions = Apollo.BaseMutationOptions<
  FetchSnapshotDataMutation,
  FetchSnapshotDataMutationVariables
>;
export const DataTypesDocument = gql`
  query DataTypes($kind: Int!) {
    dataTypes(kind: $kind)
      @rest(
        type: "DataType"
        path: "api/v1/admin/data-type?type={args.kind}"
        method: "GET"
      ) {
      displayName
      id
      name
    }
  }
`;

/**
 * __useDataTypesQuery__
 *
 * To run a query within a React component, call `useDataTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataTypesQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useDataTypesQuery(
  baseOptions: Apollo.QueryHookOptions<DataTypesQuery, DataTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DataTypesQuery, DataTypesQueryVariables>(
    DataTypesDocument,
    options
  );
}
export function useDataTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DataTypesQuery,
    DataTypesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DataTypesQuery, DataTypesQueryVariables>(
    DataTypesDocument,
    options
  );
}
export type DataTypesQueryHookResult = ReturnType<typeof useDataTypesQuery>;
export type DataTypesLazyQueryHookResult = ReturnType<
  typeof useDataTypesLazyQuery
>;
export type DataTypesQueryResult = Apollo.QueryResult<
  DataTypesQuery,
  DataTypesQueryVariables
>;
export const StoreProcedureReportsDocument = gql`
  query StoreProcedureReports {
    storeProcedureReports
      @rest(
        type: "StoreProcedureReport"
        path: "api/v1/admin/report-environment/list-by-schema?kind=report"
        method: "GET"
      ) {
      name
    }
  }
`;

/**
 * __useStoreProcedureReportsQuery__
 *
 * To run a query within a React component, call `useStoreProcedureReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreProcedureReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreProcedureReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreProcedureReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StoreProcedureReportsQuery,
    StoreProcedureReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StoreProcedureReportsQuery,
    StoreProcedureReportsQueryVariables
  >(StoreProcedureReportsDocument, options);
}
export function useStoreProcedureReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreProcedureReportsQuery,
    StoreProcedureReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StoreProcedureReportsQuery,
    StoreProcedureReportsQueryVariables
  >(StoreProcedureReportsDocument, options);
}
export type StoreProcedureReportsQueryHookResult = ReturnType<
  typeof useStoreProcedureReportsQuery
>;
export type StoreProcedureReportsLazyQueryHookResult = ReturnType<
  typeof useStoreProcedureReportsLazyQuery
>;
export type StoreProcedureReportsQueryResult = Apollo.QueryResult<
  StoreProcedureReportsQuery,
  StoreProcedureReportsQueryVariables
>;
export const StoreProcedureParametersDocument = gql`
  query StoreProcedureParameters {
    storeProcedureParameters
      @rest(
        type: "StoreProcedureParameter"
        path: "api/v1/admin/report-environment/list-by-schema?kind=parameter"
        method: "GET"
      ) {
      name
    }
  }
`;

/**
 * __useStoreProcedureParametersQuery__
 *
 * To run a query within a React component, call `useStoreProcedureParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreProcedureParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreProcedureParametersQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreProcedureParametersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StoreProcedureParametersQuery,
    StoreProcedureParametersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    StoreProcedureParametersQuery,
    StoreProcedureParametersQueryVariables
  >(StoreProcedureParametersDocument, options);
}
export function useStoreProcedureParametersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreProcedureParametersQuery,
    StoreProcedureParametersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    StoreProcedureParametersQuery,
    StoreProcedureParametersQueryVariables
  >(StoreProcedureParametersDocument, options);
}
export type StoreProcedureParametersQueryHookResult = ReturnType<
  typeof useStoreProcedureParametersQuery
>;
export type StoreProcedureParametersLazyQueryHookResult = ReturnType<
  typeof useStoreProcedureParametersLazyQuery
>;
export type StoreProcedureParametersQueryResult = Apollo.QueryResult<
  StoreProcedureParametersQuery,
  StoreProcedureParametersQueryVariables
>;
export const EnvironmentUserDocument = gql`
  query EnvironmentUser {
    environments
      @rest(
        type: "Environment"
        path: "api/v1/end-user/report-environment"
        method: "GET"
      ) {
      name
      id
      precessorEnvironmentId
      successorEnvironmentId
    }
  }
`;

/**
 * __useEnvironmentUserQuery__
 *
 * To run a query within a React component, call `useEnvironmentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnvironmentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnvironmentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnvironmentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EnvironmentUserQuery,
    EnvironmentUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EnvironmentUserQuery, EnvironmentUserQueryVariables>(
    EnvironmentUserDocument,
    options
  );
}
export function useEnvironmentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnvironmentUserQuery,
    EnvironmentUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnvironmentUserQuery,
    EnvironmentUserQueryVariables
  >(EnvironmentUserDocument, options);
}
export type EnvironmentUserQueryHookResult = ReturnType<
  typeof useEnvironmentUserQuery
>;
export type EnvironmentUserLazyQueryHookResult = ReturnType<
  typeof useEnvironmentUserLazyQuery
>;
export type EnvironmentUserQueryResult = Apollo.QueryResult<
  EnvironmentUserQuery,
  EnvironmentUserQueryVariables
>;
export const IsGlobalLoadingDocument = gql`
  query IsGlobalLoading {
    isGlobalLoading @client
  }
`;

/**
 * __useIsGlobalLoadingQuery__
 *
 * To run a query within a React component, call `useIsGlobalLoadingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsGlobalLoadingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsGlobalLoadingQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsGlobalLoadingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IsGlobalLoadingQuery,
    IsGlobalLoadingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IsGlobalLoadingQuery, IsGlobalLoadingQueryVariables>(
    IsGlobalLoadingDocument,
    options
  );
}
export function useIsGlobalLoadingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsGlobalLoadingQuery,
    IsGlobalLoadingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsGlobalLoadingQuery,
    IsGlobalLoadingQueryVariables
  >(IsGlobalLoadingDocument, options);
}
export type IsGlobalLoadingQueryHookResult = ReturnType<
  typeof useIsGlobalLoadingQuery
>;
export type IsGlobalLoadingLazyQueryHookResult = ReturnType<
  typeof useIsGlobalLoadingLazyQuery
>;
export type IsGlobalLoadingQueryResult = Apollo.QueryResult<
  IsGlobalLoadingQuery,
  IsGlobalLoadingQueryVariables
>;
export const DisplayVisibilityDocument = gql`
  query DisplayVisibility {
    displayVisibility @client
  }
`;

/**
 * __useDisplayVisibilityQuery__
 *
 * To run a query within a React component, call `useDisplayVisibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisplayVisibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisplayVisibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useDisplayVisibilityQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DisplayVisibilityQuery,
    DisplayVisibilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DisplayVisibilityQuery,
    DisplayVisibilityQueryVariables
  >(DisplayVisibilityDocument, options);
}
export function useDisplayVisibilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DisplayVisibilityQuery,
    DisplayVisibilityQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DisplayVisibilityQuery,
    DisplayVisibilityQueryVariables
  >(DisplayVisibilityDocument, options);
}
export type DisplayVisibilityQueryHookResult = ReturnType<
  typeof useDisplayVisibilityQuery
>;
export type DisplayVisibilityLazyQueryHookResult = ReturnType<
  typeof useDisplayVisibilityLazyQuery
>;
export type DisplayVisibilityQueryResult = Apollo.QueryResult<
  DisplayVisibilityQuery,
  DisplayVisibilityQueryVariables
>;
export const SelectedEnvNameDocument = gql`
  query SelectedEnvName {
    selectedEnvName @client
  }
`;

/**
 * __useSelectedEnvNameQuery__
 *
 * To run a query within a React component, call `useSelectedEnvNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedEnvNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedEnvNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectedEnvNameQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SelectedEnvNameQuery,
    SelectedEnvNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SelectedEnvNameQuery, SelectedEnvNameQueryVariables>(
    SelectedEnvNameDocument,
    options
  );
}
export function useSelectedEnvNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SelectedEnvNameQuery,
    SelectedEnvNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SelectedEnvNameQuery,
    SelectedEnvNameQueryVariables
  >(SelectedEnvNameDocument, options);
}
export type SelectedEnvNameQueryHookResult = ReturnType<
  typeof useSelectedEnvNameQuery
>;
export type SelectedEnvNameLazyQueryHookResult = ReturnType<
  typeof useSelectedEnvNameLazyQuery
>;
export type SelectedEnvNameQueryResult = Apollo.QueryResult<
  SelectedEnvNameQuery,
  SelectedEnvNameQueryVariables
>;
export const ProductionReportDocument = gql`
  query ProductionReport($id: Int!) {
    enduserReport(id: $id)
      @rest(
        type: "Report"
        path: "api/v1/end-user/report/template/{args.id}"
        method: "GET"
      ) {
      id
      name
      displayCustomFields
      parameters {
        id
        name
        description
        dataTypeId
        userRoleIds
        versionId
        queryFieldName
        query
      }
      reportDefinitionColumns {
        id
        name
        isDefault
        dataTypeId
        queryFieldName
        userRoles {
          id
          displayName
          name
        }
      }
      reportEnvironment {
        id
        name
      }
    }
  }
`;

/**
 * __useProductionReportQuery__
 *
 * To run a query within a React component, call `useProductionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductionReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductionReportQuery,
    ProductionReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProductionReportQuery, ProductionReportQueryVariables>(
    ProductionReportDocument,
    options
  );
}
export function useProductionReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductionReportQuery,
    ProductionReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProductionReportQuery,
    ProductionReportQueryVariables
  >(ProductionReportDocument, options);
}
export type ProductionReportQueryHookResult = ReturnType<
  typeof useProductionReportQuery
>;
export type ProductionReportLazyQueryHookResult = ReturnType<
  typeof useProductionReportLazyQuery
>;
export type ProductionReportQueryResult = Apollo.QueryResult<
  ProductionReportQuery,
  ProductionReportQueryVariables
>;
export const CustomFieldsDocument = gql`
  query CustomFields($companyId: Int!, $environmentId: Int!) {
    customFields(companyId: $companyId, environmentId: $environmentId)
      @rest(
        type: "ColumnMetadata"
        path: "api/v1/end-user/report/custom-fields/{args.companyId}/environment/{args.environmentId}"
        method: "GET"
      ) {
      name
    }
  }
`;

/**
 * __useCustomFieldsQuery__
 *
 * To run a query within a React component, call `useCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useCustomFieldsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomFieldsQuery,
    CustomFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomFieldsQuery, CustomFieldsQueryVariables>(
    CustomFieldsDocument,
    options
  );
}
export function useCustomFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomFieldsQuery,
    CustomFieldsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomFieldsQuery, CustomFieldsQueryVariables>(
    CustomFieldsDocument,
    options
  );
}
export type CustomFieldsQueryHookResult = ReturnType<
  typeof useCustomFieldsQuery
>;
export type CustomFieldsLazyQueryHookResult = ReturnType<
  typeof useCustomFieldsLazyQuery
>;
export type CustomFieldsQueryResult = Apollo.QueryResult<
  CustomFieldsQuery,
  CustomFieldsQueryVariables
>;
export const SavedReportDocument = gql`
  query SavedReport($id: Int!) {
    savedReport(id: $id)
      @rest(
        type: "SavedReport"
        path: "api/v1/end-user/report/user-report/{args.id}"
        method: "GET"
      ) {
      id
      name
      reportDefinition {
        id
        name
      }
    }
  }
`;

/**
 * __useSavedReportQuery__
 *
 * To run a query within a React component, call `useSavedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavedReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    SavedReportQuery,
    SavedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SavedReportQuery, SavedReportQueryVariables>(
    SavedReportDocument,
    options
  );
}
export function useSavedReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SavedReportQuery,
    SavedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SavedReportQuery, SavedReportQueryVariables>(
    SavedReportDocument,
    options
  );
}
export type SavedReportQueryHookResult = ReturnType<typeof useSavedReportQuery>;
export type SavedReportLazyQueryHookResult = ReturnType<
  typeof useSavedReportLazyQuery
>;
export type SavedReportQueryResult = Apollo.QueryResult<
  SavedReportQuery,
  SavedReportQueryVariables
>;
export const FetchReportDataDocument = gql`
  query FetchReportData($correlationId: String!, $page: Int!) {
    fetchReportData(correlationId: $correlationId, page: $page)
      @rest(
        type: "String"
        path: "api/v1/end-user/report/fetch-data?correlationId={args.correlationId}&page={args.page}"
        method: "GET"
      )
  }
`;

/**
 * __useFetchReportDataQuery__
 *
 * To run a query within a React component, call `useFetchReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchReportDataQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFetchReportDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchReportDataQuery,
    FetchReportDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FetchReportDataQuery, FetchReportDataQueryVariables>(
    FetchReportDataDocument,
    options
  );
}
export function useFetchReportDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchReportDataQuery,
    FetchReportDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchReportDataQuery,
    FetchReportDataQueryVariables
  >(FetchReportDataDocument, options);
}
export type FetchReportDataQueryHookResult = ReturnType<
  typeof useFetchReportDataQuery
>;
export type FetchReportDataLazyQueryHookResult = ReturnType<
  typeof useFetchReportDataLazyQuery
>;
export type FetchReportDataQueryResult = Apollo.QueryResult<
  FetchReportDataQuery,
  FetchReportDataQueryVariables
>;
export const GetRunReportJobStatusDocument = gql`
  query GetRunReportJobStatus($correlationId: String!) {
    runReportJobStatus(correlationId: $correlationId)
      @rest(
        type: "RunReportJobStatus"
        path: "api/v1/end-user/report/run-report?correlationId={args.correlationId}"
        method: "GET"
      ) {
      completed
      expiration
      hasError
      totalRows
    }
  }
`;

/**
 * __useGetRunReportJobStatusQuery__
 *
 * To run a query within a React component, call `useGetRunReportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunReportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunReportJobStatusQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function useGetRunReportJobStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRunReportJobStatusQuery,
    GetRunReportJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRunReportJobStatusQuery,
    GetRunReportJobStatusQueryVariables
  >(GetRunReportJobStatusDocument, options);
}
export function useGetRunReportJobStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRunReportJobStatusQuery,
    GetRunReportJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRunReportJobStatusQuery,
    GetRunReportJobStatusQueryVariables
  >(GetRunReportJobStatusDocument, options);
}
export type GetRunReportJobStatusQueryHookResult = ReturnType<
  typeof useGetRunReportJobStatusQuery
>;
export type GetRunReportJobStatusLazyQueryHookResult = ReturnType<
  typeof useGetRunReportJobStatusLazyQuery
>;
export type GetRunReportJobStatusQueryResult = Apollo.QueryResult<
  GetRunReportJobStatusQuery,
  GetRunReportJobStatusQueryVariables
>;
export const GetDownloadReportJobStatusDocument = gql`
  query GetDownloadReportJobStatus($correlationId: String!) {
    downloadReportJobStatus(correlationId: $correlationId)
      @rest(
        type: "DownloadReportJobStatus"
        path: "api/v1/end-user/report/export-report?correlationId={args.correlationId}"
        method: "GET"
      ) {
      completed
      expiration
      hasError
      fileUrl
      fileName
    }
  }
`;

/**
 * __useGetDownloadReportJobStatusQuery__
 *
 * To run a query within a React component, call `useGetDownloadReportJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadReportJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadReportJobStatusQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *   },
 * });
 */
export function useGetDownloadReportJobStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDownloadReportJobStatusQuery,
    GetDownloadReportJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDownloadReportJobStatusQuery,
    GetDownloadReportJobStatusQueryVariables
  >(GetDownloadReportJobStatusDocument, options);
}
export function useGetDownloadReportJobStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDownloadReportJobStatusQuery,
    GetDownloadReportJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDownloadReportJobStatusQuery,
    GetDownloadReportJobStatusQueryVariables
  >(GetDownloadReportJobStatusDocument, options);
}
export type GetDownloadReportJobStatusQueryHookResult = ReturnType<
  typeof useGetDownloadReportJobStatusQuery
>;
export type GetDownloadReportJobStatusLazyQueryHookResult = ReturnType<
  typeof useGetDownloadReportJobStatusLazyQuery
>;
export type GetDownloadReportJobStatusQueryResult = Apollo.QueryResult<
  GetDownloadReportJobStatusQuery,
  GetDownloadReportJobStatusQueryVariables
>;
export const ExportSavedReportDocument = gql`
  query ExportSavedReport($input: ExportSavedReportInput!) {
    exportSavedReport(input: $input)
      @rest(
        type: "String"
        path: "api/v1/end-user/report/user-report/{args.input.savedReportId}/export-report"
        method: "GET"
      )
  }
`;

/**
 * __useExportSavedReportQuery__
 *
 * To run a query within a React component, call `useExportSavedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSavedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSavedReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportSavedReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportSavedReportQuery,
    ExportSavedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExportSavedReportQuery,
    ExportSavedReportQueryVariables
  >(ExportSavedReportDocument, options);
}
export function useExportSavedReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportSavedReportQuery,
    ExportSavedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportSavedReportQuery,
    ExportSavedReportQueryVariables
  >(ExportSavedReportDocument, options);
}
export type ExportSavedReportQueryHookResult = ReturnType<
  typeof useExportSavedReportQuery
>;
export type ExportSavedReportLazyQueryHookResult = ReturnType<
  typeof useExportSavedReportLazyQuery
>;
export type ExportSavedReportQueryResult = Apollo.QueryResult<
  ExportSavedReportQuery,
  ExportSavedReportQueryVariables
>;
export const ExportRecentlyGeneratedReportDocument = gql`
  query ExportRecentlyGeneratedReport(
    $input: ExportRecentlyGeneratedReportInput!
  ) {
    exportRecentlyGeneratedReport(input: $input)
      @rest(
        type: "ExportRecentlyGeneratedReportPayload"
        path: "api/v1/end-user/report/report-snapshot/{args.input.itemId}/file-url"
        method: "GET"
      ) {
      fileUrl
    }
  }
`;

/**
 * __useExportRecentlyGeneratedReportQuery__
 *
 * To run a query within a React component, call `useExportRecentlyGeneratedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportRecentlyGeneratedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportRecentlyGeneratedReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportRecentlyGeneratedReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportRecentlyGeneratedReportQuery,
    ExportRecentlyGeneratedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExportRecentlyGeneratedReportQuery,
    ExportRecentlyGeneratedReportQueryVariables
  >(ExportRecentlyGeneratedReportDocument, options);
}
export function useExportRecentlyGeneratedReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportRecentlyGeneratedReportQuery,
    ExportRecentlyGeneratedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportRecentlyGeneratedReportQuery,
    ExportRecentlyGeneratedReportQueryVariables
  >(ExportRecentlyGeneratedReportDocument, options);
}
export type ExportRecentlyGeneratedReportQueryHookResult = ReturnType<
  typeof useExportRecentlyGeneratedReportQuery
>;
export type ExportRecentlyGeneratedReportLazyQueryHookResult = ReturnType<
  typeof useExportRecentlyGeneratedReportLazyQuery
>;
export type ExportRecentlyGeneratedReportQueryResult = Apollo.QueryResult<
  ExportRecentlyGeneratedReportQuery,
  ExportRecentlyGeneratedReportQueryVariables
>;
export const RunSavedReportDataDocument = gql`
  query RunSavedReportData($input: RunSavedReportInput!) {
    runSavedReportData(input: $input)
      @rest(
        type: "String"
        path: "api/v1/end-user/report/user-report/{args.input.savedReportId}/run-report?offset={args.input.offset}&limit={args.input.limit}"
        method: "GET"
      ) {
      reportCorrelationId
      exportFileCorrelationId
    }
  }
`;

/**
 * __useRunSavedReportDataQuery__
 *
 * To run a query within a React component, call `useRunSavedReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSavedReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSavedReportDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunSavedReportDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    RunSavedReportDataQuery,
    RunSavedReportDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RunSavedReportDataQuery,
    RunSavedReportDataQueryVariables
  >(RunSavedReportDataDocument, options);
}
export function useRunSavedReportDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RunSavedReportDataQuery,
    RunSavedReportDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RunSavedReportDataQuery,
    RunSavedReportDataQueryVariables
  >(RunSavedReportDataDocument, options);
}
export type RunSavedReportDataQueryHookResult = ReturnType<
  typeof useRunSavedReportDataQuery
>;
export type RunSavedReportDataLazyQueryHookResult = ReturnType<
  typeof useRunSavedReportDataLazyQuery
>;
export type RunSavedReportDataQueryResult = Apollo.QueryResult<
  RunSavedReportDataQuery,
  RunSavedReportDataQueryVariables
>;
export const FetchSnapshotDataJobStatusDocument = gql`
  query FetchSnapshotDataJobStatus($input: FetchSnapshotDataJobStatusInput!) {
    fetchSnapshotDataJobStatus(input: $input)
      @rest(
        type: "SnapshotDataPayload"
        path: "api/v1/end-user/report/report-snapshot/{args.input.snapshotId}/fetch-data?correlationId={args.input.correlationId}"
        method: "GET"
      ) {
      maximumRows
      hasMore
      hasError
      data
      reportDefinitionName
      userReportName
      completed
      expiration
    }
  }
`;

/**
 * __useFetchSnapshotDataJobStatusQuery__
 *
 * To run a query within a React component, call `useFetchSnapshotDataJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSnapshotDataJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSnapshotDataJobStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchSnapshotDataJobStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchSnapshotDataJobStatusQuery,
    FetchSnapshotDataJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchSnapshotDataJobStatusQuery,
    FetchSnapshotDataJobStatusQueryVariables
  >(FetchSnapshotDataJobStatusDocument, options);
}
export function useFetchSnapshotDataJobStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchSnapshotDataJobStatusQuery,
    FetchSnapshotDataJobStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchSnapshotDataJobStatusQuery,
    FetchSnapshotDataJobStatusQueryVariables
  >(FetchSnapshotDataJobStatusDocument, options);
}
export type FetchSnapshotDataJobStatusQueryHookResult = ReturnType<
  typeof useFetchSnapshotDataJobStatusQuery
>;
export type FetchSnapshotDataJobStatusLazyQueryHookResult = ReturnType<
  typeof useFetchSnapshotDataJobStatusLazyQuery
>;
export type FetchSnapshotDataJobStatusQueryResult = Apollo.QueryResult<
  FetchSnapshotDataJobStatusQuery,
  FetchSnapshotDataJobStatusQueryVariables
>;
export const ReportViewerDocument = gql`
  query ReportViewer(
    $reportId: String!
    $environment: String!
    $pathBuilder: String!
    $queryLimit: Int!
    $queryOffset: Int!
  ) {
    reportViewer(
      reportId: $reportId
      environment: $environment
      queryLimit: $queryLimit
      queryOffset: $queryOffset
      pathBuilder: $pathBuilder
    )
      @rest(
        type: "String"
        pathBuilder: $pathBuilder
        method: "GET"
        endpoint: "main"
      )
  }
`;

/**
 * __useReportViewerQuery__
 *
 * To run a query within a React component, call `useReportViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportViewerQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      environment: // value for 'environment'
 *      pathBuilder: // value for 'pathBuilder'
 *      queryLimit: // value for 'queryLimit'
 *      queryOffset: // value for 'queryOffset'
 *   },
 * });
 */
export function useReportViewerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportViewerQuery,
    ReportViewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportViewerQuery, ReportViewerQueryVariables>(
    ReportViewerDocument,
    options
  );
}
export function useReportViewerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportViewerQuery,
    ReportViewerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportViewerQuery, ReportViewerQueryVariables>(
    ReportViewerDocument,
    options
  );
}
export type ReportViewerQueryHookResult = ReturnType<
  typeof useReportViewerQuery
>;
export type ReportViewerLazyQueryHookResult = ReturnType<
  typeof useReportViewerLazyQuery
>;
export type ReportViewerQueryResult = Apollo.QueryResult<
  ReportViewerQuery,
  ReportViewerQueryVariables
>;
export const SaveReportDocument = gql`
  mutation SaveReport($input: SaveReportInput!) {
    saveReport(input: $input)
      @rest(
        type: "CreatedObject"
        path: "api/v1/end-user/report/user-report"
        method: "POST"
      ) {
      id
    }
  }
`;
export type SaveReportMutationFn = Apollo.MutationFunction<
  SaveReportMutation,
  SaveReportMutationVariables
>;

/**
 * __useSaveReportMutation__
 *
 * To run a mutation, you first call `useSaveReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReportMutation, { data, loading, error }] = useSaveReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveReportMutation,
    SaveReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveReportMutation, SaveReportMutationVariables>(
    SaveReportDocument,
    options
  );
}
export type SaveReportMutationHookResult = ReturnType<
  typeof useSaveReportMutation
>;
export type SaveReportMutationResult =
  Apollo.MutationResult<SaveReportMutation>;
export type SaveReportMutationOptions = Apollo.BaseMutationOptions<
  SaveReportMutation,
  SaveReportMutationVariables
>;
export const ParameterValuesDocument = gql`
  query ParameterValues(
    $id: Int!
    $versionId: Int!
    $reportDefinitionId: Int!
  ) {
    parameterValues(
      id: $id
      versionId: $versionId
      reportDefinitionId: $reportDefinitionId
    )
      @rest(
        type: "ColumnMetadata"
        path: "api/v1/end-user/parameter/{args.id}/version/{args.versionId}/reportdefinitionid/{args.reportDefinitionId}/values"
        method: "GET"
      ) {
      key
      value
    }
  }
`;

/**
 * __useParameterValuesQuery__
 *
 * To run a query within a React component, call `useParameterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterValuesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *      reportDefinitionId: // value for 'reportDefinitionId'
 *   },
 * });
 */
export function useParameterValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ParameterValuesQuery,
    ParameterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ParameterValuesQuery, ParameterValuesQueryVariables>(
    ParameterValuesDocument,
    options
  );
}
export function useParameterValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ParameterValuesQuery,
    ParameterValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ParameterValuesQuery,
    ParameterValuesQueryVariables
  >(ParameterValuesDocument, options);
}
export type ParameterValuesQueryHookResult = ReturnType<
  typeof useParameterValuesQuery
>;
export type ParameterValuesLazyQueryHookResult = ReturnType<
  typeof useParameterValuesLazyQuery
>;
export type ParameterValuesQueryResult = Apollo.QueryResult<
  ParameterValuesQuery,
  ParameterValuesQueryVariables
>;
export const EndUserReportsDocument = gql`
  query EndUserReports($environmentName: String!) {
    enduserReports(environmentName: $environmentName)
      @rest(
        type: "Report"
        path: "api/v1/end-user/report/template?env={args.environmentName}"
        method: "GET"
      ) {
      name
      description
      id
      parameterIds
      deployedMessage
      userIdHideDeployedMessages
      reportEnvironment {
        id
        name
        precessorEnvironmentId
        successorEnvironmentId
      }
      deployedAt
      query
      category {
        name
        id
      }
    }
  }
`;

/**
 * __useEndUserReportsQuery__
 *
 * To run a query within a React component, call `useEndUserReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndUserReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndUserReportsQuery({
 *   variables: {
 *      environmentName: // value for 'environmentName'
 *   },
 * });
 */
export function useEndUserReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    EndUserReportsQuery,
    EndUserReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EndUserReportsQuery, EndUserReportsQueryVariables>(
    EndUserReportsDocument,
    options
  );
}
export function useEndUserReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EndUserReportsQuery,
    EndUserReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EndUserReportsQuery, EndUserReportsQueryVariables>(
    EndUserReportsDocument,
    options
  );
}
export type EndUserReportsQueryHookResult = ReturnType<
  typeof useEndUserReportsQuery
>;
export type EndUserReportsLazyQueryHookResult = ReturnType<
  typeof useEndUserReportsLazyQuery
>;
export type EndUserReportsQueryResult = Apollo.QueryResult<
  EndUserReportsQuery,
  EndUserReportsQueryVariables
>;
export const DisableDeployMessageTemplateDocument = gql`
  mutation DisableDeployMessageTemplate($input: DisableDeployMessageInput!) {
    disableDeployMessageTemplate(input: $input)
      @rest(
        type: "Report"
        path: "api/v1/end-user/report/hide-deployed-message/{args.input.reportId}"
        method: "PUT"
      ) {
      id
    }
  }
`;
export type DisableDeployMessageTemplateMutationFn = Apollo.MutationFunction<
  DisableDeployMessageTemplateMutation,
  DisableDeployMessageTemplateMutationVariables
>;

/**
 * __useDisableDeployMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDisableDeployMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDeployMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDeployMessageTemplateMutation, { data, loading, error }] = useDisableDeployMessageTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableDeployMessageTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableDeployMessageTemplateMutation,
    DisableDeployMessageTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableDeployMessageTemplateMutation,
    DisableDeployMessageTemplateMutationVariables
  >(DisableDeployMessageTemplateDocument, options);
}
export type DisableDeployMessageTemplateMutationHookResult = ReturnType<
  typeof useDisableDeployMessageTemplateMutation
>;
export type DisableDeployMessageTemplateMutationResult =
  Apollo.MutationResult<DisableDeployMessageTemplateMutation>;
export type DisableDeployMessageTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    DisableDeployMessageTemplateMutation,
    DisableDeployMessageTemplateMutationVariables
  >;
export const FullDataSavedReportDocument = gql`
  query FullDataSavedReport($id: Int!) {
    fullDataSavedReport(id: $id)
      @rest(
        type: "SavedReport"
        path: "api/v1/end-user/report/user-report/{args.id}"
        method: "GET"
      ) {
      id
      name
      description
      reportDefinition {
        id
        name
      }
      userReportColumns {
        columnQueryFieldName
        order
        id
      }
      userReportParameters {
        id
        parameterId
        parameterValue
      }
      userReportSchedule {
        scheduleType
        interval
        time
        daysOfWeek
        dayOfMonth
        specialDay
        scheduleTimezone
      }
    }
  }
`;

/**
 * __useFullDataSavedReportQuery__
 *
 * To run a query within a React component, call `useFullDataSavedReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullDataSavedReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullDataSavedReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFullDataSavedReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    FullDataSavedReportQuery,
    FullDataSavedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FullDataSavedReportQuery,
    FullDataSavedReportQueryVariables
  >(FullDataSavedReportDocument, options);
}
export function useFullDataSavedReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FullDataSavedReportQuery,
    FullDataSavedReportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FullDataSavedReportQuery,
    FullDataSavedReportQueryVariables
  >(FullDataSavedReportDocument, options);
}
export type FullDataSavedReportQueryHookResult = ReturnType<
  typeof useFullDataSavedReportQuery
>;
export type FullDataSavedReportLazyQueryHookResult = ReturnType<
  typeof useFullDataSavedReportLazyQuery
>;
export type FullDataSavedReportQueryResult = Apollo.QueryResult<
  FullDataSavedReportQuery,
  FullDataSavedReportQueryVariables
>;
export const ReportSnapshotsDocument = gql`
  query ReportSnapshots {
    reportSnapshots
      @rest(
        type: "ReportSnapshots"
        path: "api/v1/end-user/report/report-snapshot"
        method: "GET"
      ) {
      id
      name
      description
      type
      createdAt
      reportDefinitionName
      reportDefinitionId
      userReportId
      columns
      parameters
    }
  }
`;

/**
 * __useReportSnapshotsQuery__
 *
 * To run a query within a React component, call `useReportSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSnapshotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportSnapshotsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReportSnapshotsQuery,
    ReportSnapshotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportSnapshotsQuery, ReportSnapshotsQueryVariables>(
    ReportSnapshotsDocument,
    options
  );
}
export function useReportSnapshotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportSnapshotsQuery,
    ReportSnapshotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportSnapshotsQuery,
    ReportSnapshotsQueryVariables
  >(ReportSnapshotsDocument, options);
}
export type ReportSnapshotsQueryHookResult = ReturnType<
  typeof useReportSnapshotsQuery
>;
export type ReportSnapshotsLazyQueryHookResult = ReturnType<
  typeof useReportSnapshotsLazyQuery
>;
export type ReportSnapshotsQueryResult = Apollo.QueryResult<
  ReportSnapshotsQuery,
  ReportSnapshotsQueryVariables
>;
export const UserReportsDocument = gql`
  query UserReports {
    userReports
      @rest(
        type: "UserReports"
        path: "api/v1/end-user/report/user-report"
        method: "GET"
      ) {
      name
      description
      id
      canShowDeployedMessage
      reportDefinitionId
      reportDefinition {
        id
        name
        isDisabled
        deployedMessage
      }
      userReportSchedule {
        scheduleType
        interval
        time
        daysOfWeek
        dayOfMonth
        specialDay
      }
    }
  }
`;

/**
 * __useUserReportsQuery__
 *
 * To run a query within a React component, call `useUserReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserReportsQuery,
    UserReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserReportsQuery, UserReportsQueryVariables>(
    UserReportsDocument,
    options
  );
}
export function useUserReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserReportsQuery,
    UserReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserReportsQuery, UserReportsQueryVariables>(
    UserReportsDocument,
    options
  );
}
export type UserReportsQueryHookResult = ReturnType<typeof useUserReportsQuery>;
export type UserReportsLazyQueryHookResult = ReturnType<
  typeof useUserReportsLazyQuery
>;
export type UserReportsQueryResult = Apollo.QueryResult<
  UserReportsQuery,
  UserReportsQueryVariables
>;
export const DisableDeployMessageDocument = gql`
  mutation DisableDeployMessage($input: DisableDeployMessageInput!) {
    disableDeployMessage(input: $input)
      @rest(
        type: "Report"
        path: "api/v1/end-user/report/user-report/{args.input.reportId}/hide-deployed-message"
        method: "PUT"
      ) {
      id
    }
  }
`;
export type DisableDeployMessageMutationFn = Apollo.MutationFunction<
  DisableDeployMessageMutation,
  DisableDeployMessageMutationVariables
>;

/**
 * __useDisableDeployMessageMutation__
 *
 * To run a mutation, you first call `useDisableDeployMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDeployMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDeployMessageMutation, { data, loading, error }] = useDisableDeployMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableDeployMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableDeployMessageMutation,
    DisableDeployMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableDeployMessageMutation,
    DisableDeployMessageMutationVariables
  >(DisableDeployMessageDocument, options);
}
export type DisableDeployMessageMutationHookResult = ReturnType<
  typeof useDisableDeployMessageMutation
>;
export type DisableDeployMessageMutationResult =
  Apollo.MutationResult<DisableDeployMessageMutation>;
export type DisableDeployMessageMutationOptions = Apollo.BaseMutationOptions<
  DisableDeployMessageMutation,
  DisableDeployMessageMutationVariables
>;
